import Vue from 'vue'
import Vuex from 'vuex'

let storeConfig = {
  state: {},
  mutations: {},
  actions:{},
  getters:{},
}
//遍历store配置
require.context('./', true, /\.js/).keys().forEach(fileName => {
  const store =  require(`${fileName}`).default
  if(store){
    storeConfig.state = Object.assign(storeConfig.state, store.state)
    storeConfig.mutations = Object.assign(storeConfig.mutations, store.mutations)
    storeConfig.actions = Object.assign(storeConfig.actions, store.actions)
    storeConfig.getters = Object.assign(storeConfig.getters, store.getters)
  }
})

// 使用vuex
Vue.use(Vuex)
const store = new Vuex.Store(storeConfig)
export default store